(function(api) {
	api.GetRacunSFields = GetRacunSFields;
	api.RacunObrisi = RacunObrisi;
	api.GetOcevidSFields = GetOcevidSFields;
	api.OcevidById = OcevidById;
	api.OcevidZaPartnerZaRazdoblje = OcevidZaPartnerZaRazdoblje;
	api.RacunImaStavke = RacunImaStavke;
	api.RacunUrudzbirajSap = RacunUrudzbirajSap;
	api.RacunUrudzbirajOtpremiSap = RacunUrudzbirajOtpremiSap;
	api.OcevidUrudzbiranISpremljenUDigArh = OcevidUrudzbiranISpremljenUDigArh;
	api.datumDA = datumDA;
	
	function GetRacunSFields(){
		return $.dsDirectCall({
			method: "GetRacunSFields"
		});
	}
	
	function RacunObrisi(godina,racun){
		return $.dsDirectCall({
			method: "RacunObrisi",
			params: [ godina,racun ]
		});
	}
	
	function GetOcevidSFields(){
		return $.dsDirectCall({
			method: "GetOcevidSFields",
		});
	}
	
	function OcevidById(ocevid){
		return $.dsDirectCall({
			method: "OcevidById",
			params: [ ocevid ]
		});
	}
	
	function OcevidZaPartnerZaRazdoblje(ocevid, partner, subjekt, datum){
		return $.dsDirectCall({
			method: "OcevidZaPartnerZaRazdoblje",
			params: [ ocevid, partner, subjekt, datum  ]
		});
	}
	
	function RacunImaStavke(godina, racun){
		return $.dsDirectCall({
			method: "RacunImaStavke",
			params: [ godina, racun ]
		});
	}
	
	function RacunUrudzbirajSap(ocevid){
        return $.dsDirectCall({
            method: "RacunUrudzbirajSap",
            params: [ocevid]
        });
    }
    
    function RacunUrudzbirajOtpremiSap(ocevid){
        return $.dsDirectCall({
            method: "RacunUrudzbirajOtpremiSap",
            params: [ocevid]
        });
    }
    
    function OcevidUrudzbiranISpremljenUDigArh(ocevid){
        return $.dsDirectCall({
            method: "OcevidUrudzbiranISpremljenUDigArh",
            params: [ocevid]
        });
    }
    
    function datumDA(){
        return $.dsDirectCall({
            method: "datumDA",
            params: []
        });
    }
	
} (konto.ao.api = {}));